/* unplugin-vue-components disabled */import script from "./AppList.vue?vue&type=script&setup=true&name=AppList&lang=js"
export * from "./AppList.vue?vue&type=script&setup=true&name=AppList&lang=js"

import "./AppList.vue?vue&type=style&index=0&id=092db4b3&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-092db4b3"]])

export default __exports__